import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CoaterLicense } from '@workspace-app/odatabackend/QualicoatBackendModel';
import { CoaterLicenseFilter, CoaterLicensePagination, LicenseOrderBy } from './license.state';

export const CoaterLicenseActions = createActionGroup({
  source: 'CoaterLicense',
  events: {
    'Load Coater Licenses': props<{
      pagination: CoaterLicensePagination;
      filter: CoaterLicenseFilter;
      orderBy: LicenseOrderBy;
    }>(),
    'Load Coater Licenses Success': props<{ licenseNumbers: CoaterLicense[]; count: number }>(),
    'Load Coater Licenses Failure': props<{ error: string }>(),

    'Withdraw Coater License': props<{ coaterLicenseId: string; withdrawalDate: Date; withdrawalReason: string }>(),
    'Withdraw Coater License Success': emptyProps(),
    'Withdraw Coater License Failure': props<{ error: string }>(),

    'Grant Coater License': props<{ coaterLicenseId: string; expiryDate: Date }>(),
    'Grant Coater License Success': emptyProps(),
    'Grant Coater License Failure': props<{ error: string }>(),
  },
});
